import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

import { Container } from "../components/globalstyles.js"

const Footer = () => {
  return (
    <StyledFooter>
      <StyledContainer>
        © {new Date().getFullYear()} <Link to="/">Fizjobobas.pl</Link> |
        Wszelkie Prawa Zastrzeżone
      </StyledContainer>
    </StyledFooter>
  )
}

const StyledFooter = styled.footer`
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.white};
  position: absolute;
  background-color: ${({ theme }) => theme.secondary};

  a {
    color: inherit;
    text-decoration: underline;
  }
`

const StyledContainer = styled(Container)`
  padding-top: 20px;
  padding-bottom: 20px;
`

export default Footer
